export const IS_FABRIC = "nativeFabricUIManager" in global;
//# sourceMappingURL=architecture.js.map